import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { serviceURLService } from '../service/serviceURL';
import { ToasterService } from '../services/toaster.service';
import { RouterLink } from '@angular/router';
import { ProfileDataObj } from './profile.modal';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.css'],
  providers: [ToasterService]
})
export class EditProfileComponent implements OnInit {
  profileData = new ProfileDataObj();
  loading: boolean;
  profileMaxDate = new Date();
  private onDestroy$: Subject<void> = new Subject<void>();
  isCompanyNamePresent:boolean = true;

  constructor(private router: Router, private toasterService: ToasterService, private _location: Location, private serviceURLService: serviceURLService) {

  }

  ngOnInit() {
    this.getProfileDetails();
  }

  getProfileDetails() {
    this.loading = true;
    let userID = localStorage.getItem('userID');
    this.serviceURLService.getProfileDetails(userID).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.loading = false;
      this.profileData = successData.response.profileData;
      this.profileData.dob = successData.response.profileData.dob ? new Date(successData.response.profileData.dob) : '';
      this.isCompanyNamePresent = (successData.response.profileData.assignedToClient.length > 0) ? true : false;
    }, errorData => {
      this.loading = false;
      if (errorData.error.status === 401) {
        this.router.navigate(['/login']);
      } else if (errorData.error.status === 403 || errorData.error.status === 400) {
        //this.error = errorData.error.message;
        //console.log("ERROR: ",this.error);
      }
    });
  }


  updateProfileDetails() {
    this.loading = true;
    let sendProfileData = {
      "name": this.profileData.name,
      "mobile": this.profileData.mobile,
      "email": this.profileData.email,
      "dob": (new Date(this.profileData.dob).getTime()).toString(),
      "company": this.profileData.company,
      "family": '[]'
    }
    this.serviceURLService.setProfileDetails(sendProfileData).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.loading = false;
      this.toasterService.showErrorToaster(successData.message);
      // this (localstorage) code will be remove when we are done from code review point
      localStorage.setItem('name', successData.response.profileData.name);
      localStorage.setItem('mobileNumber', JSON.parse(successData.response.profileData.mobile));
      // setTimeout(() => {
      //   this.router.navigate(['profile']);
      // }, 500);
    }, errorData => {
      this.loading = false;
    });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
    }
    

}
